export default __webpack_public_path__ + "static/media/escaleratelescopica.07d99557.png";